import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useArenaMedalEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: null,
        name: '',
        rank: null,
        image: null,
        imageFile: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        imageFile: {},
        rank: { required, integer, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        fetch: executeAction({
            request: () => arenaService.medal.get(route.params.id),
            onSuccess: ({ data }) => Object.assign(model, data),
            onError: () => router.push({ name: ROUTE_NAME_ARENA.MEDAL.INDEX })
        }),
        update: excuteAndNotify({
            validator: v$,
            request: () => arenaService.medal.update(model.id, model.name, model.rank, model.imageFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.MEDAL.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => arenaService.medal.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.MEDAL.INDEX })
        })
    };

    return { model, v$, actions };
}
